<template>
  <div class="payment">
    <el-card>
        <div class="cell_item">
        <div class="cell_label">用户编码</div>
        <div class="cell_content">
            {{data.code}}
        </div>
      </div>
      <div class="cell_item">
        <div class="cell_label">用户卡号</div>
        <div class="cell_content">
          {{data.yhkh}}
        </div>
      </div>
      <div class="cell_item">
        <div class="cell_label">用户名称</div>
        <div class="cell_content">
            {{data.name}}
        </div>
      </div>
      <div class="cell_item">
        <div class="cell_label">用户地址</div>
        <div class="cell_content">
            {{data.address}}
        </div>
      </div>

      <div  class="detail">
        <div class="detail_label">缴费详情</div>
        <div class="detail_content">
          <p v-if="!data.jsList.length" class="no_data">{{msg?msg:'暂无欠费记录'}}</p>
          <mt-checklist v-if="data.jsList.length" align="right" v-model="value" @change="getValue" :options="data.jsList"></mt-checklist>
        </div>
      </div>

      <div v-if="data.jsList.length" class="payment_money">
        <span class="payment_label">缴费金额</span>
        <span class="payment_value">￥{{qfje}}</span>
      </div>
    </el-card>
    <button v-if="data.jsList.length" class="btn_bind" @click="pay" type="primary">立 即 缴 费</button>
  </div>
</template>

<script>
import { getBill, pay } from "../../../api";
import Cell from "../../../components/cell";
import { weixinInit } from "../../../utils";
export default {
  data() {
    return {
      data: {
        jsList: [],
      },
      companyCode: sessionStorage.getItem("companyCode"),
      thirdId: sessionStorage.getItem("thirdId"),
      value: [],
      qfje: 0,
      msg: ''
    };
  },
  methods: {
    pay() {
      let mjsf = [];
      this.value.map((v) => {
        mjsf = mjsf.concat(v.mjsfList);
      });
      if (mjsf.length) {
        pay({
          mjsf: mjsf,
          state: sessionStorage.getItem("state"),
        }).then((res) => {
          if (res) {
            const cfg = res.data;
            wx.chooseWXPay({
              timestamp: cfg.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: cfg.nonceStr, // 支付签名随机串，不长于 32 位
              package: cfg.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: cfg.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: cfg.paySign, // 支付签名
              success: () => {
                this.$toast("支付成功");
                this.$router.go(-1);
              },
            });
          }
        });
      } else {
        this.$toast("请先选中要缴费的金额");
      }
    },
    getValue(item) {
      let qfje = 0;
      item.map((v) => {
        qfje += v.hjQfje;
      });
      this.qfje = qfje;
    },
  },
  components: {
    Cell,
  },
  mounted() {
    weixinInit(sessionStorage.getItem('state'));
    getBill({
      companyCode: this.companyCode,
      code: this.$route.query.code,
    }).then((res) => {
      if (res) {
        this.data = res.data;
        const jsList = res.data.jsList;
        this.msg = res.data.msg
        jsList.map((v) => {
          v.label = `${v.cnq}年度欠费金额：￥${v.hjQfje}`;
        });
      }
    });
  },
};
</script>

<style scoped>
.payment {
  border-radius: 5px;
  padding: 3%;
  min-height: 90%;
}
.detail,
.payment_money {
  background: #fff;

  /* padding: 0 3%; */
}
.cell_item{
    display: flex;
    justify-content: space-between;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #f1f1f1;
}
.cell_content {
     font-size: 16px;
     font-weight: bold;
     overflow: hidden;
text-overflow:ellipsis;
white-space: nowrap;
}
.cell_label{
    font-size: 13px;
    width: 20%;
}
.detail_label {
  line-height: 40px;
  font-size: 13px;
}
.detail_content {
  font-size: 16px;
  line-height: 20px;
  height: 100px;

}
.payment_money {
  margin-top: 10px;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}
.payment_value {
  color: rgb(228, 153, 15);
  font-size: 16px;
  font-weight: bold;
}
.btn_bind {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/view/jryw/jf/Payment.vue